module.exports = __webpack_public_path__ + "media/LeaseToUpload.753ced71.svg";